import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Nav from "../../header/Nav.component";
import ResultsModal from "./resultsModal";
import { Modal } from "react-bootstrap";

const Output = () => {
  const columns = [
    {
      name: "Analysis Run",
      selector: "name",
      sortable: true,
      format: ({ name, _id }) => (
        <span className="project-name">
          <Link to={`/${_id}/summary`}>{name}</Link>
        </span>
      ),
    },
    {
      name: "Initiater",
      selector: "user",
      sortable: true,
      format: ({ user_nickname }) => <span>{user_nickname}</span>,
    },
    {
      name: "Date Created",
      selector: "year",
      sortable: true,
      format: (row) => (
        <span>
          {moment.unix(row.date.created).format("MM/DD/YYYY")},&nbsp; (
          {moment(
            moment.unix(row.date.created).format("MMDDYYYY"),
            "MMDDYYYY"
          ).fromNow()}
          )
        </span>
      ),
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
    },
  ];

  const allProjects = useSelector((state) => state.projects.userProjects);
  const [openResultsModal, setOpenResultsModal] = useState(false)
  // console.log(allProjects)

  return (
    <>
      <Nav active={5} />
      <div className="content">
        <DataTable
          columns={columns}
          data={allProjects}
          defaultSortField="title"
          pagination
          highlightOnHover
          pointerOnHover
          // progressPending={projectsPending}
          onRowClicked={() => setOpenResultsModal(true)}
          // progressComponent={<Loader />}
        />
        <Modal
          show={openResultsModal}
          onHide={() => setOpenResultsModal(false)}
          // backdrop="static"
          keyboard={true}
          // fullscreen={true}
          centered
          // size="lg"
          dialogClassName="div-block-12"
          // contentClassName="div-block-12"
        >
          <ResultsModal setOpenResultsModal={setOpenResultsModal}/>
        </Modal>
      </div>
    </>
  );
};



export default Output;
